import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';
import { Session, Stats, FunnelStage } from '../types';

export function useSessions(minScore = 0) {
  const [sessions, setSessions] = useState<Session[]>([]);
  const [loading, setLoading]   = useState(true);

  const fetch = useCallback(async () => {
    try {
      const { data } = await api.get('/dashboard/sessions', { params: { minScore } });
      setSessions(data.sessions ?? []);
    } catch { /* API not running — use mock */ }
    finally { setLoading(false); }
  }, [minScore]);

  useEffect(() => { fetch(); const t = setInterval(fetch, 5000); return () => clearInterval(t); }, [fetch]);
  return { sessions, loading, refresh: fetch };
}

export function useSession(id: string) {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    api.get(`/dashboard/sessions/${id}`)
      .then(({ data }) => setSession(data.session))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [id]);

  return { session, loading };
}

export function useStats() {
  const [stats, setStats]   = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    try {
      const { data } = await api.get('/dashboard/stats');
      setStats(data.stats);
    } catch {}
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetch(); const t = setInterval(fetch, 5000); return () => clearInterval(t); }, [fetch]);
  return { stats, loading };
}

export function useFunnel() {
  const [funnel, setFunnel]  = useState<FunnelStage[]>([]);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    try {
      const { data } = await api.get('/dashboard/funnel');
      setFunnel(data.funnel ?? []);
    } catch {}
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetch(); const t = setInterval(fetch, 10000); return () => clearInterval(t); }, [fetch]);
  return { funnel, loading };
}

export function useHotLeads() {
  const [leads, setLeads]    = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    try {
      const { data } = await api.get('/dashboard/hot-leads');
      setLeads(data.leads ?? []);
    } catch {}
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetch(); const t = setInterval(fetch, 5000); return () => clearInterval(t); }, [fetch]);
  return { leads, loading, refresh: fetch };
}
